var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighHeel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 4H3.11111C3.11111 5.01752 3.00355 6.90206 2.6387 8.39834C2.36648 9.51386 2 10.6449 2 11.7926C2 12.3725 2.39198 12.8818 2.95839 13.0371L3.11111 13.0789V18.9032C3.11111 19.5089 3.60862 20 4.22222 20H5.33333C5.94694 20 6.44444 19.5089 6.44444 18.9032V13.9931L9.55887 14.8467C11.0016 15.2425 12 16.539 12 18.0171V18.9032C12 19.5089 12.4975 20 13.1111 20H21.3056C21.4922 20 21.6616 19.9272 21.7864 19.8094C21.9181 19.6846 22 19.5089 22 19.3145V18.0685C22 16.659 21.3899 15.5515 19.9782 15.3394C17.9508 15.0347 15.6332 13.7232 14.4548 12.0668C12.2606 8.98154 11.1816 5.58893 10.8889 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighHeel3);
export default __webpack_public_path__ + "static/media/high-heel-3.0aa28359d950270db3b4de19fb6bbe22.svg";
export { ForwardRef as ReactComponent };